import {Component, OnDestroy, OnInit} from "@angular/core";
import {Field} from "../models/field.model";
import {SharedDataService} from "../../../services/shared/shared-data.service";
import {TranslateService} from "@ngx-translate/core";
import {DetailService} from "../../../services/details/detail.service";
import {Subscription} from "rxjs/internal/Subscription";

@Component({
	selector: "tig-form-select",
	template: `
		<div
			*ngIf="BOO_visible"
			class="dynamic-field form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<select class="form-control"
					[formControlName]="OBJ_field_config.name"
					(change)="setValue($event.target.value)">
				  <option value="">{{"please_select"|translate}}</option>
				  <option *ngFor="let OBJ_option of OBJ_field_config.options"
					  value="{{OBJ_option.id}}"
					  [disabled]="OBJ_option?.deprecated"
					  [ngClass]="{'tig-deprecated': OBJ_option?.deprecated}">
					  {{getLabelNameOption(OBJ_option)|translate}}
					  <ng-container *ngIf="OBJ_option?.deprecated">
						   - {{'deprecated'|translate}}
					  </ng-container>
				  </option>
				</select>
				<div class="tig-hint" *ngIf="OBJ_field_config.dependent_fields">
					<span *ngIf="BOO_one_dependent_field">{{ "oSelect.sWarningDependentField"|translate:{value:this.STR_dependent_fields} }}</span>
					<span *ngIf="!BOO_one_dependent_field">{{ "oSelect.sWarningDependentFields"|translate:{value:this.STR_dependent_fields} }}</span>
				</div>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	`
})
export class FormSelectComponent extends Field implements OnInit, OnDestroy
{

	private ARR_subscriptions: Subscription[] = [Subscription.EMPTY];
	BOO_visible = true;

	/**
	 * Function > constructor
	 */
	constructor(private OBJ_translate_service: TranslateService, private OBJ_shared_service: SharedDataService, private OBJ_detail_service: DetailService)
	{
		super();
	} // end function constructor


	/**
	 * LifecycleHook > ngOnInit
	 */
	ngOnInit()
	{
		this.getDependentFields(this.OBJ_translate_service);

		if(this.OBJ_field_config._links && this.OBJ_field_config._links.options && this.OBJ_field_config._links.options.depends_on)
		{
			// Wenn der Wert noch nicht befüllt ist, blende Feld aus
			if(!this.OBJ_field_config.value)
			{
				this.BOO_visible = false;
			} // end if

			Object.keys(this.OBJ_field_config._links.options.depends_on).forEach(key =>
			{
				let STR_dependency_name = this.OBJ_field_config._links.options.depends_on[key];

				// Wenn Elternfeld befuellt ist, blende Feld ein
				if(this.getFormControlByName(STR_dependency_name) && this.getFormControlByName(STR_dependency_name).value)
				{
					this.BOO_visible = true;
				} // end if

				// Hoere auf Wertaenderung des "Elternfeldes"
				this.ARR_subscriptions.push(this.OBJ_shared_service.getValue(STR_dependency_name).subscribe(
					value => {
						this.BOO_visible = false;
						// Da sich das "Elternfeld" geaendert hat setze Wert zurueck - sowohl in der Formcontrol als auch in der Config selbst (Anzeige & Abspeicherung)
						this.setValue("");
						let OBJ_form_control = this.getFormControl();
						OBJ_form_control.setValue("");
						// Sende notification dass wert zurueckgesetzt wurde - dynamicFormControl greift hier nicht, da Wert nicht dirty ist
						this.OBJ_shared_service.sendValue(this.OBJ_field_config.name, "");

						// Wert ist befuellt - wenn Feld zurueckgesetzt wird ist value leer oder null
						if(value)
						{

							// URL bei der Daten nachgeladen werden sollen
							let STR_reload_url = this.OBJ_field_config._links.options.href.replace(key, value);
							// TODO: do this with chaining and pipe later, for now quick and dirty to fix errors
							this.OBJ_detail_service.getHelper(STR_reload_url, null, 'FormSelectComponent').subscribe(
								OBJ_contents_helper => {
									this.OBJ_detail_service.fillOptionsSelect(this.OBJ_field_config, OBJ_contents_helper);
									this.BOO_visible = true;
								}
							); // end subscribe

						} // end if

					})); // end subscribe

			}); // end foreach
		}


	} // end LifecycleHook ngOnInit


	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions to prevent memory leak
		this.ARR_subscriptions.forEach(
			(OBJ_subscription: Subscription) => { OBJ_subscription.unsubscribe(); }
		);
	} // end function ngOnDestroy

} // end class FormSelectComponent
